//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "NewAgenda",
  data: function() {
    return {
      data: {},
      id: '',
      selectFile: '',
    };
  },
  mounted() {
    this.id = this.$route.params.id
    if(this.id != -1){
      this.$http.get('/agenda_byid/'+ this.id, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.data = result.data
      })
    }
  },
  methods: {
    
    onSubmit() {
      this.$refs.name.validate();
      this.$refs.desc.validate();
      this.$refs.date.validate();
      this.$refs.location.validate();
      if (
        this.$refs.name.hasError ||
        this.$refs.desc.hasError ||
        this.$refs.date.hasError ||
        this.$refs.location.hasError
      ) {
        this.formHasError = true;
      } 
      else {
        if (this.data.id) {
          this.data.updatedBy = this.$store.state.currentAdmin.username
          this.data.updatedDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
          this.$http
            .put(
              "/update_agenda/" + this.id, this.data,{
                headers: { Authorization: "Bearer " + token}
              })
            .then((result) => {
              this.$router.push("/admin/agenda");
              this.$q.notify({
                icon: "done",
                color: "positive",
                message: "Saved",
              });
            });
        } else {
          this.data.createdBy = this.$store.state.currentAdmin.username
          this.$http
            .post("/new_agenda/", this.data, {
              headers: { Authorization: "Bearer " + token}
            })
            .then((result) => {
              this.$router.push("/admin/agenda");
              this.$q.notify({
                icon: "done",
                color: "positive",
                message: "Saved",
              });
            });
        }
      }
    },
  },
};
